import type { ReactNode } from 'react';

import { withEmphasis } from './emphasisText';
import './landingRef.css';

type Props = {
  title: string;
  intro: string;
  /** The lane(s) under this heading — Signal Fire. */
  children: ReactNode;
};

/**
 * "The Circle is only the start" — the umbrella over the lane that is not Circles.
 *
 * This used to be a two-panel bento of City Sparks and Mutuals, with Signal Fire as a separate
 * section above it. That was wrong twice over. Mutuals is not another way in, it is what any lane
 * arrives at, and it was already explained at the end of the Circle walkthrough — the panel here
 * repeated that beat a screen later in almost the same words. Signal Fire, which genuinely is
 * another way in, sat outside the heading that describes it.
 *
 * So the section is a heading and its lane, not boxed in a card.
 */
export function BeyondTheCircleSection({ title, intro, children }: Props) {
  return (
    <section className="beyond-circle-section" aria-labelledby="beyond-circle-heading">
      <header className="beyond-circle-section__intro">
        <h2 id="beyond-circle-heading" className="ml-heading-serif ml-text-heading">
          {title}
        </h2>
        <p className="ml-text-body-secondary">{withEmphasis(intro)}</p>
      </header>

      <div className="beyond-circle-section__lanes">{children}</div>
    </section>
  );
}
